import React from 'react';
import PropTypes from 'prop-types';
import { getCustomClassesForPayload } from 'utils/common';
import Link from 'components/Link';
import ImageLoad from 'components_v2/common/ImageV2';
import {
  isAffiliate,
  getAffiliatePartnerName,
  getEncodedAffiliateLink,
} from 'utils/Affiliate';

class Image extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isImageMagnified: false,
      isCaptionShownWhenImageMagnified: false,
    };
  }
  handleImageModalClick = () => {
    this.setState({
      isImageMagnified: !this.state.isImageMagnified,
    });
  };
  getImageUrl() {
    const { msid, imagesize } = this.props;
    const url = `https://static.toiimg.com/photo/imgsize-${imagesize},msid-${msid}/${msid}.jpg`;
    return url;
  }
  getCaption() {
    const { title, isWapView } = this.props;
    const s = this.props.styleObj;
    const tthis = this;
    const captionCloseBtn = (
      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          tthis.setState({
            isCaptionShownWhenImageMagnified: false,
          });
        }}
      >
        X
      </button>
    );
    const capObj = {
      title,
      expandedCaptionClass: '',
      captionCloseBtn: '',
    };
    if (!isWapView && this.state.isImageMagnified) {
      if (this.state.isCaptionShownWhenImageMagnified) {
        capObj.title = title;
        capObj.captionCloseBtn = captionCloseBtn;
        capObj.expandedCaptionClass = '';
      } else {
        capObj.title = 'READ CAPTION';
        capObj.captionCloseBtn = '';
        capObj.expandedCaptionClass = s.readCaption;
      }
    } else if (isWapView && this.state.isImageMagnified) {
      capObj.title = title;
    }

    return (
      <span
        className={`${s.imagecap} ${capObj.expandedCaptionClass}`}
        onClick={() =>
          tthis.setState({ isCaptionShownWhenImageMagnified: true })
        }
      >
        {capObj.title}
        {capObj.captionCloseBtn}
      </span>
    );
  }

  handleImageClick = () => {
    if (!this.state.isImageMagnified && this.props.showMagnifiedModal) {
      this.handleImageModalClick();
    }
  };

  getImageHtml(showLazyLoad) {
    const s = this.props.styleObj;
    const { noWidth, placeHolderSrc } = this.props;
    const image = (
      <div
        data-pos={this.props.key}
        className={`${
          !(this.props.prime || this.props.nic) ? 'id-r-component' : ''
        } ${s.image} ${s.clearfix} ${
          !this.props.isWapView && this.props.prime && this.props.classes
            ? getCustomClassesForPayload(this.props.classes.toLowerCase(), s)
            : ''
        } ${
          !this.state.isImageMagnified && this.props.showMagnifiedModal
            ? s.showMagnifier
            : ''
        }
        ${this.state.isImageMagnified ? s.magnifiedimage : ''}`}
      >
        {this.state.isImageMagnified && (
          <button
            type="button"
            className={s.imageCloseButton}
            onClick={this.handleImageModalClick}
          >
            X
          </button>
        )}
        <div className={s.imageContainer}>
          <ImageLoad
            src={this.props.url}
            msid={this.props.msid}
            // eslint-disable-next-line no-nested-ternary
            width={noWidth ? '' : this.props.isSPOTLIGHTArticle ? 800 : 600}
            alt={this.props.title}
            onClick={this.handleImageClick}
            title={
              this.props.prime && this.props.title !== '#'
                ? this.props.title
                : this.props.caption
            }
            placeHolderSrc={
              placeHolderSrc || 'https://static.toiimg.com/photo/83033472.cms'
            }
            lazyload={showLazyLoad && !this.props.prime}
          />
          {this.props.caption && (
            <div className={s.imageCaption}>{this.props.caption}</div>
          )}
          {this.props.prime &&
            !this.props.noCaption &&
            this.props.title &&
            this.props.title !== '#' &&
            this.getCaption()}
        </div>
      </div>
    );
    return image;
  }

  render() {
    const s = this.props.styleObj;
    const { overridelink, target, skipAffiliateHandling } = this.props;
    const isAffiliateLink = !skipAffiliateHandling && isAffiliate(overridelink);
    const affiliatePartnerName = getAffiliatePartnerName(overridelink);
    let returnHtml;
    if (overridelink && !isAffiliateLink) {
      returnHtml = (
        <Link target={target} href={overridelink}>
          {this.getImageHtml()}
        </Link>
      );
    } else if (isAffiliateLink) {
      const affiliateLink = getEncodedAffiliateLink(
        this.props.title,
        overridelink,
      ).replace('<title>', encodeURIComponent(this.props.title));
      returnHtml = (
        <div className={s.affiliate_wrapper}>
          <a
            className={`${affiliatePartnerName.toLowerCase()}-link`}
            href={affiliateLink}
            alt={this.props.title}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            {this.getImageHtml()}
            {!this.props.prime && (
              <div className={s.affiliatebox}>
                <h4>{this.props.title}</h4>
                <div className={s.buynow_wrapper}>
                  <div className={`${s.logo} ${s[affiliatePartnerName]}`} />
                  <div className={`${s.buy_btn} ${s[affiliatePartnerName]}`}>
                    BUY NOW
                  </div>
                </div>
              </div>
            )}
          </a>
        </div>
      );
    } else {
      returnHtml = this.getImageHtml(true);
    }

    return returnHtml;
  }
}

Image.propTypes = {
  url: PropTypes.string.isRequired,
  caption: PropTypes.string,
  overridelink: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string,
  styleObj: PropTypes.shape({}).isRequired,
  classes: PropTypes.string,
  prime: PropTypes.bool,
  key: PropTypes.number,
  isWapView: PropTypes.bool,
  imagesize: PropTypes.string,
  msid: PropTypes.string,
  noCaption: PropTypes.bool,
  showMagnifiedModal: PropTypes.bool,
  nic: PropTypes.bool,
  skipAffiliateHandling: PropTypes.bool,
  noWidth: PropTypes.bool,
  placeHolderSrc: PropTypes.string,
};

Image.defaultProps = {
  overridelink: '',
  title: '',
  target: '',
  caption: '',
  classes: '',
  prime: false,
  key: 0,
  isWapView: false,
  imagesize: '',
  msid: '',
  noCaption: false,
  showMagnifiedModal: false,
  nic: false,
  skipAffiliateHandling: false,
  noWidth: false,
  placeHolderSrc: '',
};

export default Image;
